<template>
  <div>
    <div class="info-area">
      <!-- 材料列表 -->
      <div v-for="item in applicationMaterialList" :key="item.id" class="document-item">
        <div class="document-header">
          <div class="document-title">
            <span>{{ item.materialCode }}. {{ item.materialTitle }}</span>
          </div>
          <Button v-if="item.templateUrl" type="link" @click="downloadTemplate(item.templateUrl)">下载</Button>
        </div>
        <div class="document-upload">
          <MaterialFileManager
                :materialId="item.materialId"
                :initialFiles="item.files || []"
                :supportedFormats="item.supportedFormats || []"
              @update:files="(materialId, files) => $emit('update-files', materialId, files)"
              @upload-success="(file, materialId) => $emit('upload-success', file, materialId)"
              @delete="(file, materialId) => $emit('delete-file', file, materialId)"
          />
        </div>
      </div>
    </div>

    <div class="notice-container">
      <h3 class="notice-title">{{ categoryInfo?.readingFileName || '申请须知' }}</h3>
      <div class="notice-content">
        <ol class="notice-list">
          <li class="notice-item">
            本单位已详细审阅、理解、知悉<a @click="previewFileUrl(categoryInfo?.readingFileUrl, categoryInfo?.readingFileName)" class="policy-link">{{ categoryInfo?.readingFileName }}</a>及相关材料内容，承诺接受所有条款约束，如有违反，自愿承担有关责任。
          </li>
          <li class="notice-item">
            本单位提交的所有材料真实、有效、合法，若有不符，自愿承担相应法律责任。
          </li>
        </ol>
      </div>
      <div class="notice-agreement">
        <Checkbox v-model="agreedToNotice" @change="$emit('notice-agree', $event)">
          我已阅读并同意上述申请须知内容
        </Checkbox>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Button, Checkbox, message } from 'ant-design-vue';
import MaterialFileManager from '@/components/MaterialFileManager/index.vue';
import { previewFile } from '@/api/file';

defineProps({
  applicationMaterialList: {
    type: Array,
    default: () => []
  },
  categoryInfo: {
    type: Object,
    default: null
  }
});

defineEmits(['download-template', 'update-files', 'upload-success', 'delete-file', 'notice-agree']);

const agreedToNotice = ref(false);

const downloadTemplate = (url) => {
  if (!url) return;
  
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const previewFileUrl = async (url, fileName) => {
  if (!url) return;
  
  try {
    const response = await previewFile(url);
    
    if (response && (response instanceof Blob || response instanceof ArrayBuffer)) {
      const blob = response instanceof ArrayBuffer ? new Blob([response]) : response;
      const blobUrl = window.URL.createObjectURL(blob);
      
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.location.href = blobUrl;
        newWindow.document.title = fileName || '文件预览';
      } else {
        message.error('请允许弹出新窗口');
      }
    } else {
      message.error('文件预览失败');
    }
  } catch (error) {
    console.error('文件预览失败:', error);
    message.error('文件预览失败，请重试');
  }
};
</script>

<style scoped lang="less">
.info-area {
  margin-bottom: 20px;
  padding: 10px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.document-item {
  margin-bottom: 15px;
}

.document-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.document-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.document-upload {
  padding: 10px;
  background-color: #fafafa;
  border-radius: 4px;
}

.notice-container {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  padding: 20px;
  margin-top: 20px;
}

.notice-title {
  font-size: 16px;
  font-weight: 600;
  color: #d48806;
  margin-top: 0;
  margin-bottom: 15px;
}

.notice-content {
  color: #666;
  font-size: 14px;
  line-height: 1.8;
}

.notice-list {
  margin: 0;
  padding-left: 20px;
}

.notice-item {
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.policy-link {
  color: #1890ff;
  text-decoration: underline;
}

.notice-agreement {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px dashed #ffe58f;
}
</style>